
export const AUTOPAY_SUCCESS_MESSAGES = {
  scheduledBanner: 'constantsAutopaySuccessScheduledBanner',

  updateBanner: 'constantsAutopaySuccessUpdateBanner',

  updateBannerCutoff: 'constantsAutopaySuccessUpdateBannerCutoff',
} as const;

export const AUTOPAY_DELETE_MESSAGES = {
  successHeader: 'constantsAutopayDeleteSuccessHeader',

  successMessage: 'constantsAutopayDeleteSuccessMessage',

  successReflectTimeInfo: 'constantsAutopayDeleteSuccessReflectTimeInfo',

  windowClosedHeader: 'constantsAutopayDeleteWindowClosedHeader',

  windowClosedMessage: 'constantsCutoffWindowDeleteWindowClosed',

  windowClosedSuccessMessage: 'constantsAutopayDeleteWindowClosedSuccessMessage',

  errorHeader: 'constantsAutopayDeleteErrorHeader',

  errorMessage: 'constantsAutopayDeleteErrorMessage',

  proceedToDelete: 'constantsAutopayDeleteProceedToDelete',
} as const;

export const AUTOPAY_INELIGIBLE_MESSAGES = {
  header: 'constantsAutopayIneligibleHeader',

  messageTemplate: 'constantsAutopayIneligibleMessageTemplate',

  noAutopayMessage: 'constantsAutopayIneligibleNoAutopayMessage',

  investorW01: 'constantsAutopayIneligibleInvestorW01',
} as const;

export const SAME_DAY_RESTRICTION_MESSAGES = {
  cantDeleteSameDay: {
    title: 'commonMessagesSetupAutopay',
    content: 'constantsSameDayCantDeleteSameDayContent',
    closeButtonLabel: 'commonButtonsContinue',
  },

  cantDeleteNextTwoBusinessDay: {
    title: 'commonMessagesSetupAutopay',
    content: 'constantsSameDayCantDeleteNextTwoBusinessDayContent',
    closeButtonLabel: 'commonButtonsContinue',
  },

  cantSetupSameDay: {
    title: 'paymentsAutopayDeleteAutopay',
    content: 'paymentsAutopayDeleteAutopayMessage',
    closeButtonLabel: 'commonButtonsConfirm',
  },

  cantSetupNextTwoBusinessDay: {
    title: 'paymentsAutopayDeleteAutopay',
    content: 'constantsSameDayCantSetupNextTwoBusinessDayContent',
    closeButtonLabel: 'commonButtonsConfirm',
  },

  processingDelete1Day: 'constantsSameDayProcessingDelete1Day',

  processingDelete2Days: 'constantsSameDayProcessingDelete2Days',
} as const;

export const CUTOFF_WINDOW_MESSAGES = {
  editWindowClosed: 'constantsCutoffWindowEditWindowClosed',

  draftInProcess: 'constantsCutoffWindowDraftInProcess',

  deleteWindowClosed: 'constantsCutoffWindowDeleteWindowClosed',
} as const;

export const SEMIMONTHLY_ELIGIBILITY_ERROR_MESSAGES: Record<string, string> = {
  PaymentDueWasInPreviousOrCurrentMonthsAndDaysPastDue: 'servicesErrorsAutopaySemimonthlyPastDue',
} as const;

export const PAYMENT_ELIGIBILITY_ERROR_MESSAGES: Record<string, string> = {
  PaymentDueDateBelongsToNextThreeMonth: 'constantsPaymentEligibilityPrepaid3Months',

  PaymentDueWasInPreviousOrCurrentMonthsAndDaysPastDue: 'servicesErrorsAutopayBiweeklyPastDue',

  PaymentDueInNextMonthAndDateHasPassedSecondWednesdaySixPm: 'constantsPaymentEligibilityBiweeklyCutoff',

  PaymentDueWasInPreviousMonths: 'constantsPaymentEligibilityPastDueMonthly',

  'Error-NumberOfOnlineActivePayment': 'constantsPaymentEligibilityMaxPayments',

  InvestorIdStop: 'constantsPaymentEligibilityInvestorStop',

  PaymentPlanDelinquentDueToPlanBroken: 'constantsPaymentEligibilityPaymentPlanBroken',

  InvestorIDW01: 'constantsPaymentEligibilityInvestorW01',
} as const;

export const ADDITIONAL_PRINCIPAL_MESSAGES = {
  maxError: 'constantsPaymentAdditionalPrincipalMaxError',

  maxEscrowError: 'constantsPaymentAdditionalPrincipalMaxEscrowError',

  pastDueRequired: 'constantsPaymentStatusAdditionalPaymentsDisabled',

  reinstatementExceeded: 'paymentAmountRepaymentAdditionalHint',
} as const;

export const PAYMENT_PROCESSING_MESSAGES = {
  processingNotice: 'constantsPaymentProcessingNotice',

  scheduledPaymentWarning: {
    title: 'constantsPaymentScheduledPaymentWarningTitle',
    message: 'constantsPaymentScheduledPaymentWarningMessage',
  },
} as const;
